// extracted by mini-css-extract-plugin
export default {"wrapper":"AddClientForm_wrapper__vQE7N","controlWrapper":"AddClientForm_controlWrapper__nFbdg","phoneInputWrapper":"AddClientForm_phoneInputWrapper__pldnC"};